function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "text/text-\\u9593\\u8DDD",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(3.000000, 3.000000)",
  fill: "#555555",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle",
  points: "11 8 11 10 0 10 0 8"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle",
  points: "11 13.5 11 15.5 0 15.5 0 13.5"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Rectangle",
  points: "11 2.5 11 4.5 0 4.5 0 2.5"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(11.500000, 0.500000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Line",
  points: "4.3 1.9 4.3 14.9 2.8 14.9 2.8 1.9"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0.531478714 2.41434803 3.5 0.039531 6.46852129 2.41434803 5.53147871 3.58565124 3.5 1.95999964 1.46852129 3.58565124"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  transform: "translate(3.500000, 14.812591) scale(-1, -1) translate(-3.500000, -14.812591) ",
  points: "0.531478714 15.414348 3.5 13.039531 6.46852129 15.414348 5.53147871 16.5856512 3.5 14.9599996 1.46852129 16.5856512"
}))));

function SvgTextSpace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "text/text-\u9593\u8DDD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextSpace);
export default __webpack_public_path__ + "static/media/text_space.1eefb2a8.svg";
export { ForwardRef as ReactComponent };